export const BOE_AMOUNT = 145
// export const MEMBER_DISCOUNT_BOE = 65;
export const CST_MEMBERSHIP = 49.99
export const SERVICE_TYPE = 'PAYMENT'

//export const MEMBER_DISCOUNT_COF = 50
// export const MEMBER_DISCOUNT_MX = 50


//MX Airspaces Credit Card Fee
export const CREDIT_CARD_FEE = 1.04 //4%
